import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Caption from 'LuxKit/Typography/Caption'

const Container = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: normal;
`

const Subtext = styled(Caption).attrs({
  colour: 'critical' as const,
  align: 'center' as const,
})`
  display: block;
  margin-top: ${rem(2)};
`

function AbTestsButtonLabel() {
  return (
    <Container>
      AB Tests
      <Subtext variant="small">
        Only visible for staff
      </Subtext>
    </Container>
  )
}

export default AbTestsButtonLabel
